<script setup lang="ts"></script>

<template>
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_231_10324)">
            <path
                d="M2 2.5V3.75H22V2.5H2ZM0.75 4.375V2.5V1.25H2H22H23.25V2.5V4.375V17.5V18.75H22H2H0.75V17.5V4.375ZM22 5H2V17.5H22V5ZM8.25 10C8.58152 10 8.89946 9.8683 9.13388 9.63388C9.3683 9.39946 9.5 9.08152 9.5 8.75C9.5 8.41848 9.3683 8.10054 9.13388 7.86612C8.89946 7.6317 8.58152 7.5 8.25 7.5C7.91848 7.5 7.60054 7.6317 7.36612 7.86612C7.1317 8.10054 7 8.41848 7 8.75C7 9.08152 7.1317 9.39946 7.36612 9.63388C7.60054 9.8683 7.91848 10 8.25 10ZM8.25 6.25C8.91304 6.25 9.54893 6.51339 10.0178 6.98223C10.4866 7.45107 10.75 8.08696 10.75 8.75C10.75 9.41304 10.4866 10.0489 10.0178 10.5178C9.54893 10.9866 8.91304 11.25 8.25 11.25C7.58696 11.25 6.95107 10.9866 6.48223 10.5178C6.01339 10.0489 5.75 9.41304 5.75 8.75C5.75 8.08696 6.01339 7.45107 6.48223 6.98223C6.95107 6.51339 7.58696 6.25 8.25 6.25ZM5.19141 16.25H3.875L5.125 12.5H11.375L12.625 16.25H11.3086L10.4766 13.75H6.02734L5.19531 16.25H5.19141ZM13.875 7.5H14.5H19.5H20.125V8.75H19.5H14.5H13.875V7.5ZM13.875 10H14.5H19.5H20.125V11.25H19.5H14.5H13.875V10ZM13.875 12.5H14.5H19.5H20.125V13.75H19.5H14.5H13.875V12.5Z"
                fill="#151515"
            />
        </g>

        <defs>
            <clipPath id="clip0_231_10324">
                <rect
                    width="22.5"
                    height="20"
                    fill="white"
                    transform="translate(0.75)"
                />
            </clipPath>
        </defs>
    </svg>
</template>
